'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var StyledThemeProvider = require('../../providers/StyledThemeProvider.js');
var pudoFormatTranslation = require('./pudoFormatTranslation.js');
var index = require('../Language/index.js');
var styles = require('./styles.js');
var Fees = require('./Fees.js');
var pudoMethod = require('../../transformers/pudoMethod.js');
var index$1 = require('../TextLink/index.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PudoCard = option => {
  const {
    linksNoneDefault,
    linksNoneHover,
    buttonsPrimaryDefault
  } = nthHookTheme.useTheme();
  const {
    onClick,
    defaultValue,
    dropOff,
    fees,
    title: defaultTitle,
    description,
    pudoActionType,
    preferred,
    locale,
    includeCurrency
  } = option;
  const id = pudoMethod.generatePudoId(option);
  if (!pudoActionType) return null;
  const {
    iconType,
    title,
    subtitle,
    externalUrl,
    free
  } = pudoFormatTranslation.pudoFormatTranslation(option);
  const selected = id === pudoMethod.generatePudoId(defaultValue);
  return /*#__PURE__*/React__default["default"].createElement(styles.PudoCardStyle, {
    value: id,
    key: id,
    onClick: onClick,
    selected: selected
  }, /*#__PURE__*/React__default["default"].createElement(styles.PudoCardGrid, null, iconType && /*#__PURE__*/React__default["default"].createElement(styles.PudoIcon, {
    icon: iconType
  }), /*#__PURE__*/React__default["default"].createElement(styles.PudoTitle, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: title,
    defaultString: defaultTitle
  })), /*#__PURE__*/React__default["default"].createElement(styles.PudoSubtitle, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: subtitle,
    defaultString: description
  }), (dropOff === null || dropOff === void 0 ? void 0 : dropOff.externalStoreLocatorUrl) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    href: dropOff.externalStoreLocatorUrl,
    target: "_blank",
    stopPropagation: true,
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: externalUrl,
    noWrap: true
  })))), /*#__PURE__*/React__default["default"].createElement(styles.PudoExtraInfo, null, /*#__PURE__*/React__default["default"].createElement(Fees["default"], {
    fees: fees,
    labelFreeKey: free,
    locale: locale,
    includeCurrency: includeCurrency
  }))), preferred && /*#__PURE__*/React__default["default"].createElement(styles.FavoriteIcon, {
    icon: "Favorite",
    fill: selected ? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor) ?? style.getBorderColor(buttonsPrimaryDefault) : '#ccc'
  }));
};
var PudoCard$1 = StyledThemeProvider.withStyledThemeProvider(PudoCard, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover', 'buttonsPrimaryDefault', 'bodytextDefaultNone', 'headersMediumNone']
});

exports["default"] = PudoCard$1;
